export default __webpack_public_path__ + "static/media/professor.d472b757.jpeg";